import { loadRemoteModule } from "@cw-elements/mfe-setup/load";
import {
  getCurrentWorkspace,
  getDefaultWorkspace,
} from "app-redux/selectors/licensingAccounts.selector";
import { RoutePaths, history } from "core/history";
import React from "react";
import { useSelector } from "react-redux";
import { useConfig, type CWElementsConfig } from "@cw-elements/config";
import { Layout } from "antd";
import { getCurrentUser } from "app-redux/selectors/accounts.selector";
import { LoadingOutlined } from "@ant-design/icons";

export interface QuotaMgtProps {
  getConfigInstance: () => CWElementsConfig;
  workspaceId: string;
  onCancel: () => void;

  organizationId?: string;
  propertyId?: string;
  afterSave?: () => void;
}
const QuotaMgt = React.lazy(() =>
  loadRemoteModule<QuotaMgtProps>("quota-mgt/index")
);

export function QuotaMgtPage() {
  const currentWorkspaceId = useSelector(getCurrentWorkspace)?.id;
  const defaultWorkspaceId = useSelector(getDefaultWorkspace);
  const user = useSelector(getCurrentUser);

  const ws =
    currentWorkspaceId ||
    defaultWorkspaceId ||
    user?.default_licensing_account_id;

  return ws ? (
    <Layout.Content>
      <React.Suspense
        fallback={
          <div style={{ margin: 12 }}>
            <LoadingOutlined />
          </div>
        }
      >
        <QuotaMgt
          getConfigInstance={useConfig}
          workspaceId={ws}
          onCancel={() => {
            history.push({
              pathname: RoutePaths.PLANS(),
              search: location.search,
            });
          }}
        />
      </React.Suspense>
    </Layout.Content>
  ) : null;
}
